import React, {useEffect, useRef} from "react";
import "./UiPopup.css";


type UiPopupType = {
    className?: string,
    isOpen: boolean,
    onClose: () => void,
    children: React.ReactNode
}

export const UiPopup: React.FC<UiPopupType> = (props) => {
    const popupRef = useRef<HTMLDivElement>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
            props.onClose();
        }
    };

    useEffect(() => {
        if (props.isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [props.isOpen]);
    return (
        <>
            {props.isOpen &&
                <div>
                    <div className="fixed inset-0 bg-black opacity-50 z-40"></div>
                    <div ref={popupRef}
                        className={"fixed left-1/2 top-1/2 rounded-xl overflow-hidden " +
                            "border-purple-blue border-2 z-50 translate-50-50" +
                            (props.className ? ` ${props.className}` : "")}
                    >
                        {props.children}
                    </div>
                </div>
            }
        </>
    )
}
